<template>
    <div class="d-flex align-items-start justify-content-between pb-4 mb-2 border-bottom-md">
        <div class="d-flex align-items-start">
            <div class="position-relative flex-shrink-0">

                <h3 class="h3">
                    Update Whitelabel Configuration
                </h3>

                <p>
                    This controls the look and feel of the portal that your clients see.
                </p>

            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style></style>